import { EditorState } from 'draft-js';
import adjustBlockDepthForContentState from 'draft-js/lib/adjustBlockDepthForContentState';

var adjustBlockDepth = function adjustBlockDepth(editorState, adjustment, maxDepth) {
  var content = adjustBlockDepthForContentState(editorState.getCurrentContent(), editorState.getSelection(), adjustment, maxDepth);
  return EditorState.push(editorState, content, 'adjust-depth');
};

export default adjustBlockDepth;